import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
let App = class App extends Vue {
  // #region 外部传参
  // #endregion
  // #region 内部属性
  // private JCSP = (window as any).JCSP
  // #endregion
  // #region 事件
  created() {
    this.init();
  }
  // #endregion
  // #region 方法
  init() {
    // 在初始化的时候定义登录方法
    // this.JCSP.login = () => console.log('login')
    // this.JCSP.init()
  }
};
App = __decorate([Component], App);
export default App;